module.exports = __webpack_public_path__ + "img/hide-result-title-lock.0a954fc2.png";